"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _saraivaUi = require("@minha-biblioteca/saraiva-ui/");
var _styles = _interopRequireDefault(require("./styles"));
var _References = _interopRequireDefault(require("../References"));
var _Auth = require("../../contexts/Auth");
var _Pdf = _interopRequireDefault(require("../../api/Pdf"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ReferencesPopover(props) {
  var HASH = 'references';
  var {
    openReference,
    setOpenReference,
    pdf,
    copyValue
  } = props;
  var {
    auth
  } = (0, _Auth.useAuth)();
  var matches = (0, _core.useMediaQuery)('(min-width:770px)');
  var classes = (0, _styles.default)();
  var [hash, setHash] = (0, _react.useState)(global.location.hash);
  var [reference, setReference] = (0, _react.useState)('');
  (0, _react.useEffect)(() => {
    function onBackNavigation() {
      if (hash.includes(HASH)) {
        setOpenReference(false);
      }
      setHash(global.location.hash);
    }
    window.addEventListener('hashchange', onBackNavigation);
    return () => window.removeEventListener('hashchange', onBackNavigation);
  }, [hash, setOpenReference]);
  (0, _react.useEffect)(() => {
    if (openReference) {
      global.location.hash = HASH;
    } else if (global.location.hash.includes(HASH)) {
      window.history.back();
    }
  }, [openReference]);
  var anchorOrigin = matches ? {
    vertical: 'top',
    horizontal: 'left'
  } : {
    vertical: 'top',
    horizontal: 'center'
  };
  var transformOrigin = matches ? {
    vertical: 'top',
    horizontal: 'left'
  } : {
    vertical: 'top',
    horizontal: 'center'
  };
  var spaceStyle = matches ? {
    top: 90,
    left: 105
  } : {
    top: 40,
    right: 16
  };
  var handleClosePopover = () => {
    setOpenReference(false);
  };
  (0, _react.useEffect)(() => {
    var {
      applicationToken,
      sessionToken,
      uuid
    } = auth;
    _Pdf.default.getBook(applicationToken, sessionToken, uuid).then(data => setReference(data.abnt));
  }, [auth]);
  return /*#__PURE__*/_react.default.createElement(_core.Popover, {
    open: openReference,
    onClose: handleClosePopover,
    anchorOrigin: anchorOrigin,
    transformOrigin: transformOrigin,
    classes: {
      paper: classes.rootPopoverReference
    },
    style: spaceStyle
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.title,
    variant: "h6"
  }, "Refer\xEAncia"), /*#__PURE__*/_react.default.createElement(_core.Divider, {
    className: classes.divider
  }), /*#__PURE__*/_react.default.createElement(_References.default, {
    copyValue: copyValue,
    pdf: pdf,
    reference: reference
  }), /*#__PURE__*/_react.default.createElement(_core.Divider, {
    className: classes.divider,
    style: {
      margin: '12px 0 0 0'
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.bottom
  }, /*#__PURE__*/_react.default.createElement(_saraivaUi.Button, {
    color: "primary",
    onClick: handleClosePopover
  }, "FECHAR")));
}
var _default = exports.default = ReferencesPopover;